import { Badge, Button, Dropdown, Grid, Menu, Select, Space } from 'antd';
import { MenuProps } from 'antd/lib';
import { useTokenContext } from 'contexts/resource/ResourceContext';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetLocale, useLogout, useSetLocale } from '@refinedev/core';
import LanguageLabels from 'components/header/data';
import { BellOutlined, DownOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import routeName from 'core/common/routeName';
import { getOrganizationName } from 'pages/profile/apiCall';
import { useSocketNotificationContext } from 'contexts/socketNotificationContext/SocketNotificationContext';

const { useBreakpoint } = Grid;

const HeaderContainerView = ({
  saveLang,
  filterOption,
  saveOrg,
  saveProgram,
  handleToggleNotifications,
  notificationsVisible,
}: any) => {
  const locale = useGetLocale();
  const screens = useBreakpoint();
  const { i18n } = useTranslation();
  const currentLocale = locale();
  const changeLanguage = useSetLocale();
  const navigate = useNavigate();
  const { userDetails } = useTokenContext();
  const {
    orgId,
    setCurrentLang,
    organizationList,
    userProgramList,
    programId,
  } = useTokenContext();
  // const screens = useBreakpoint();
  const { notificationMessages } = useSocketNotificationContext();
  const { mutate: logout } = useLogout();
  const menuItemsLang: MenuProps['items'] = [...(i18n.languages || [])]
    .sort()
    .map((lang: string) => ({
      key: lang,
      onClick: async () => {
        await setCurrentLang(lang);
        await changeLanguage(lang);
        await saveLang(lang);
      },
      // icon: (
      //   <span style={{ marginRight: 8 }}>
      //     <Avatar size={16} src={imageFlag(lang)} />
      //   </span>
      // ),
      label: LanguageLabels[lang] || lang,
    }));
  console.log('menuItemsLang', menuItemsLang);

  const menu = (
    <Menu>
      <Menu.Item
        key="profile"
        onClick={() => {
          navigate(routeName.profile);
        }}
      >
        Profile
      </Menu.Item>
      <Menu.Item
        key="logout"
        onClick={() => {
          logout();
        }}
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  const handleOrgChange = (e: string) => {
    saveOrg(e);
  };

  const handleProgramChange = (e) => {
    saveProgram(e);
  };

  useEffect(() => {
    if (
      userProgramList?.length > 0 &&
      !userProgramList.some((prog) => prog.value === programId)
    ) {
      handleProgramChange(userProgramList[0].value);
    }
  }, [userProgramList]);

  function getNotificationCount(notificationmsg) {
    return notificationmsg?.filter((msg) => !msg?.read)?.length; // return non read messages
  }
  return (
    <Space size="middle">
      {organizationList?.length > 1 ? (
        <Select
          className="org-select"
          style={{ width: 300 }}
          value={organizationList?.length > 0 ? orgId : undefined}
          placeholder="Select Organisation"
          onChange={(e) => handleOrgChange(e)}
          showSearch
          options={organizationList}
          optionFilterProp="children"
          filterOption={filterOption}
        />
      ) : null}
      {userProgramList?.length > 1 ? (
        <Select
          className="org-select"
          style={{ width: 300 }}
          value={userProgramList?.length > 0 ? programId : null}
          placeholder="Select Program"
          onChange={(e) => handleProgramChange(e)}
          showSearch
          options={userProgramList}
          optionFilterProp="children"
          filterOption={filterOption}
        />
      ) : null}
      <Dropdown
        className="multilingual"
        menu={{
          items: menuItemsLang,
          selectedKeys: currentLocale ? [currentLocale] : [],
        }}
      >
        <a
          style={{ color: 'inherit' }}
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          <Space>
            <div
              style={{
                display: screens.lg ? 'block' : 'none',
              }}
            >
              {LanguageLabels[currentLocale]}
              <DownOutlined
                style={{
                  fontSize: 'var(--font-xs)',
                  marginLeft: 'var(--spacing-xs)',
                }}
              />
            </div>
          </Space>
        </a>
      </Dropdown>

      <div id="notifications">
        <Badge
          count={
            !notificationsVisible &&
            notificationMessages &&
            notificationMessages?.length > 0
              ? getNotificationCount(notificationMessages)
              : 0
          }
          className="z-10"
        >
          <BellOutlined
            onClick={handleToggleNotifications}
            className="text-[24px] text-neutral-10 cursor-pointer"
          />
        </Badge>
      </div>

      <Dropdown overlay={menu} placement="bottomRight">
        <Space size="middle">
          <Button
            style={{
              color: 'primary',
              fontWeight: 'bold',
              borderRadius: '50%',
              backgroundColor: 'var(--neutral-60)',
            }}
            icon={<UserOutlined className="avatar-icon" />}
            // onClick={() => navigate(routeName.profile)}
          />
        </Space>
      </Dropdown>
      <div className="ml-md">
        <div className="font-semibold text-base text-neutral-10">{`${userDetails?.user_first_name} ${userDetails?.user_last_name}`}</div>
        <div className="text-sm text-neutral-10 mt-xs">
          {getOrganizationName(userDetails?.organization_id)}
        </div>
      </div>
    </Space>
  );
};

export default HeaderContainerView;
